import React, { useContext, useEffect, useState } from "react";
import GeneralTable from "../../../commons/GeneralTable";
import { Tag } from "antd";
import { useTranslation } from "react-i18next";
import { SocketContext } from "../../../context/SocketContext";
import { Error, Success } from "../../../commons/Messages/Messages";
import { isAuthenticated } from "../../../commons/Auth/auth";
import { generalErrorAlert } from "../../../commons/GeneralErrorAlert";
import axios from "axios";

const predefinedvalues = () => {
  const { t } = useTranslation("dashboard");
  const socket = useContext(SocketContext);
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState("");
  const [searchText, setSearchText] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize] = useState(9);

  const handleSearch = value => {
    setSearchText(value);
    setPageNo(1);
  };

  const getData = async () => {
    await axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/predefinedValuesRoutes`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          setData(res.data);
          setTotalCount(res.data.count);
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        generalErrorAlert(err);
      });
  };

  const merged = Object.values(
    data.reduce((acc, curr) => {
      if (!acc[curr.Module] && !acc[curr.Slug]) {
        acc[curr.Slug] = {
          Slug: curr.Slug,
          Module: curr.Module,
          Name: []
        };
      }
      acc[curr.Slug].Name.push(curr.Name);
      return acc;
    }, {})
  );

  useEffect(() => {
    getData();
  }, []);

  const columns = [
    {
      title: t("Module"),
      dataIndex: "Module",
      key: "Module",
      mobile: "subtitle",
      render: text => t(text)
    },
    {
      title: t("Name"),
      dataIndex: "Slug",
      key: "Slug",
      mobile: "title",
      render: text => text.split(".")[1]
    },
    {
      title: t("Values"),
      dataIndex: "Name",
      key: "Name",
      render: text => (
        <div className="predefined-values__tags">
          {text.map((text, i) => (
            <Tag key={i}>{text}</Tag>
          ))}
        </div>
      )
    }
  ];

  return (
    <GeneralTable
      pageNo={pageNo}
      pageSize={pageSize}
      totalCount={totalCount}
      data={merged}
      columns={columns}
      setPageNo={setPageNo}
    />
  );
};

export default predefinedvalues;
